import styled from 'styled-components';

import { breakPoints } from '@r1-frontend/entities/Layout/_deps/constants/breakpoints';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import Input from '@r1-frontend/ui-react/components/input';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Container = styled.div`
    background: ${COLORS.BgSubstrate};
    border-radius: 32px;
    padding: 24px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    margin-top: 80px;
`;

export const MainText = styled.div`
    text-align: right;
    ${FONTS.L};
    margin: 20px 10px 0;

    @media (max-width: ${breakPoints.tablet}) {
        text-align: center;
    }
`;

export const EmailInput = styled(Input)`
    max-width: 314px;
    margin: 30px 10px 0;
`;

export const ButtonBlock = styled.div`
    flex-wrap: nowrap;
    width: 347px;
    margin: 30px 10px 0;

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
    }
`;

export const Button = styled(BaseButton)`
    flex: 0 0 auto;
    height: 48px;
    padding: 9px 24px;
    margin-right: 12px;

    @media (max-width: ${breakPoints.mobile}) {
        margin-right: 0;
        margin-bottom: 12px;
    }
`;

export const Policy = styled.div`
    text-align: left;
    ${FONTS.XXS};
    color: ${COLORS.TextHint};
    display: inline;

    @media (max-width: ${breakPoints.tablet}) {
        text-align: center;
    }
`;

export const PolicyLink = styled.a`
    color: ${COLORS.TextHint};
    text-decoration: underline;
`;
